import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ContextProvider } from './context/index';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import addToPrototype from './utils/addToPrototype';

addToPrototype();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContextProvider>
      <App />
      </ContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// 2026-05-20: Service Worker DESACTIVADO.
// El SW estaba causando que estilistas vieran bundles viejos con bugs ya
// arreglados (caso SOHO Arequipa: modal "true" en loop, texto "Recargar"
// en vez de "Reintentar"). Esta app necesita datos frescos del backend
// en cada carga; offline-first no aporta valor para estilistas/comandas.
// Adicionalmente: unregister + limpieza de caches del SW viejo para
// liberar a los usuarios atrapados con el bundle anterior.
serviceWorkerRegistration.unregister();
if (typeof window !== "undefined" && "caches" in window) {
  (window as any).caches.keys().then((names: string[]) => {
    names.forEach((name: string) => (window as any).caches.delete(name));
  }).catch(() => { /* ignore */ });
}